<template>
  <div class="form-container">
    <label
      class="text-bold mb-0"
      v-if="label"
      :id="`label-${id}`"
      :for="id"
    >
      <span v-if="translateText">
        {{ $tc(label, labelCount) }}<span class="text-muted" v-if="required">*</span>
      </span>
      <span v-else>{{ label }}<span class="text-muted" v-if="required">*</span></span>
    </label>

    <div class="text-sm-left text-muted" v-if="helpText">
      <small>{{ $tc(helpText) }}</small>
    </div>

    <div>
      <slot name="input"></slot>
    </div>

    <transition-group name="fade-up-fast">
      <div v-for="error in errors" :key="error">
        <v-field-error
          :message="error"
        />
      </div>
    </transition-group>
  </div>
</template>

<script>
import { GenericInputMixin } from '@/common/utils/mixins';
import FieldError from '@/common/components/FieldError.vue';

export default {
  name: 'GenericInput',
  components: {
    'v-field-error': FieldError,
  },
  mixins: [
    GenericInputMixin,
  ],
};
</script>
